/**
 * Widget version - updated for CI/CD pipeline test
 */
export const WIDGET_VERSION = '1.0.0';

/**
 * Widget settings type - re-exported from shared types
 */
export type { WidgetSettings } from '@experiencelocal/types/widget';

/**
 * Default widget settings
 */
export const DEFAULT_WIDGET_SETTINGS = {
  primaryColor: '#0f172a',
  theme: 'light' as const,
  layout: 'grid' as const,
  columns: 3,
  showImages: true,
  showPrices: true,
  showDuration: true,
  showRatings: true,
  enableSearch: true,
  enableCategoryFilter: true,
  showPoweredBy: true,
  /** Enable horizontal carousel on mobile instead of vertical list */
  mobileCarousel: false,
};

/**
 * Booking flow steps
 */
export const BOOKING_STEPS = {
  SELECT_DATE: 'date',
  SELECT_TIME: 'time',
  GUEST_INFO: 'guest',
  ADD_ONS: 'addons',
  SUMMARY: 'summary',
  PAYMENT: 'payment',
  SUCCESS: 'success',
} as const;

export type BookingStep = (typeof BOOKING_STEPS)[keyof typeof BOOKING_STEPS];

/**
 * Widget message types for iframe communication
 */
export const WIDGET_MESSAGE_TYPES = {
  READY: 'el-widget-ready',
  RESIZE: 'el-resize',
  ERROR: 'el-widget-error',
  BOOKING_COMPLETE: 'el-widget-booking',
  NAVIGATION: 'el-widget-navigation',
} as const;
